import TContractEditCancelAccount from './index.vue';

TContractEditCancelAccount.install = app => {
  app.component(TContractEditCancelAccount.name, TContractEditCancelAccount);
};

export default TContractEditCancelAccount;
